/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Byoa_SavingInputs */

const en_byoa_saving = /** @type {(inputs: Byoa_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saving…`)
};

const id_byoa_saving = /** @type {(inputs: Byoa_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menyimpan…`)
};

/**
* | output |
* | --- |
* | "Saving…" |
*
* @param {Byoa_SavingInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const byoa_saving = /** @type {((inputs?: Byoa_SavingInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Byoa_SavingInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_byoa_saving(inputs)
	return en_byoa_saving(inputs)
});